import { dataUserFilter } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserFilter = /*#__PURE__*/createIcon(dataUserFilter)
export default IconUserFilter
